import React, { useEffect } from "react";
import Login from "../../components/login";
const LoginPag = () => {
  useEffect(() => {
    // GET request using fetch inside useEffect React hook
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      <Login />
    </div>
  );
};
export default LoginPag;
